import { render, staticRenderFns } from "./CollegeListRecommend.vue?vue&type=template&id=3a5a37e4&scoped=true"
import script from "./CollegeListRecommend.vue?vue&type=script&lang=js"
export * from "./CollegeListRecommend.vue?vue&type=script&lang=js"
import style0 from "./CollegeListRecommend.vue?vue&type=style&index=0&id=3a5a37e4&prod&scoped=true&lang=less"
import style1 from "./CollegeListRecommend.vue?vue&type=style&index=1&id=3a5a37e4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a37e4",
  null
  
)

export default component.exports